import { PLATFORM } from '@common/constants'

export const priceWillFailToProcessErrorMessage =
    'The total is between 1k and 2k which will fail to process in lower environments. ' +
    'If you need to test a price failure scenario in lower environments, then ' +
    'you must add the ?allowtestprice=true parameter to the URL to bypass this check.'

// In lower environments, prevent form submission if calculated total is between 1k and 2k
// because it will result in a CyberSource error when it tries to process the purchase
// due to that range being a test price range for lower environments on the Cybersource third-party side
// See also src/common/hooks/useFlexForm.ts
export const willPriceFailToProcess = (price: number, environment: string, queryStringParams: string) => {
    const isProduction = environment === PLATFORM.PROD
    const urlParams = new URLSearchParams(queryStringParams)
    const isCyberSourceTestPrice = price >= 1000 && price <= 2000
    const isTestPriceOverrideEnabled = urlParams.get('allowtestprice') === 'true'
    const priceWillFail = !isProduction && isCyberSourceTestPrice && !isTestPriceOverrideEnabled
    return priceWillFail
}
